// Arizona QSO Party — 15 county abbreviations (3 letters) per azqp.org rules.
export const AZQP_COUNTY_ABBREVS = [
  'APH', 'CHS', 'CNO', 'GLA', 'GHM', 'GLE', 'LPZ', 'MCP', 'MHV', 'NVO', 'PMA', 'PNL', 'SCZ', 'YVP', 'YMA'
];

export const AZQP_COUNTY_NAMES = {
  APH: 'Apache',
  CHS: 'Cochise',
  CNO: 'Coconino',
  GLA: 'Gila',
  GHM: 'Graham',
  GLE: 'Greenlee',
  LPZ: 'La Paz',
  MCP: 'Maricopa',
  MHV: 'Mohave',
  NVO: 'Navajo',
  PMA: 'Pima',
  PNL: 'Pinal',
  SCZ: 'Santa Cruz',
  YVP: 'Yavapai',
  YMA: 'Yuma'
};

const COUNTY_NAME_TO_ABBREV = {
  apache: 'APH',
  cochise: 'CHS',
  coconino: 'CNO',
  gila: 'GLA',
  graham: 'GHM',
  greenlee: 'GLE',
  'la paz': 'LPZ',
  maricopa: 'MCP',
  mohave: 'MHV',
  navajo: 'NVO',
  pima: 'PMA',
  pinal: 'PNL',
  'santa cruz': 'SCZ',
  yavapai: 'YVP',
  yuma: 'YMA'
};

export function getAzqpCountyAbbrev(stusps, countyName) {
  if (String(stusps || '').toUpperCase() !== 'AZ') {
    return null;
  }

  const normalized = String(countyName || '')
    .trim()
    .replace(/\s+(County|Parish|Borough)$/i, '')
    .toLowerCase();

  return COUNTY_NAME_TO_ABBREV[normalized] || null;
}

export function isAzqpCounty(value) {
  return AZQP_COUNTY_ABBREVS.includes(String(value || '').trim().toUpperCase());
}
